<app-picture-source
  [imgSrc]="img"
  [alt]="alt"
  [presets]="'pro-style-filter' | imgPreset"
  useWebp="true"
  useLazyLoad="true"
  preloadImages="true"
  handleX2="true"
  width="164"
  height="83"
></app-picture-source>
